import { Container, Grid, Paper } from '@material-ui/core'
import React, { useState } from 'react'
import { components, useTranslation } from 'cng-web-lib'

import VsMigrationSyncLogViewForm from './VsMigrationSyncLogViewForm'
import VsMigrationSyncLogAddForm from './VsMigrationSyncLogAddForm'
import VsMigrationSyncLogEditForm from './VsMigrationSyncLogEditForm'
import Namespace from 'src/constants/locale/Namespace'
import VsMigrationSyncLogKeys from 'src/constants/locale/key/VsMigrationSyncLog'
import {
  constants,
} from 'cng-web-lib'

const {
  locale: {
    key: {
      UiComponentKeys,
    },
  },
} = constants

const { CngTabs } = components

function AddPage({ history, showNotification }) {
  const [lockedOnFirstTab, setLockedOnFirstTab] = useState(true)
  const [vsMigrationSyncLogId, setVsMigrationSyncLogId] = useState('')
  const { translate } = useTranslation([
    Namespace.VS_MIGRATION_SYNC_LOG,
    Namespace.UI_COMPONENT
  ])
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    let vsMigrationSyncLog = translate(
      Namespace.VS_MIGRATION_SYNC_LOG,
      VsMigrationSyncLogKeys.TITLE
    )
    let tabLockedMessage = translate(
      Namespace.UI_COMPONENT,
      UiComponentKeys.Tabs.PLEASE_SUBMIT_FIRST,
      {
        title: vsMigrationSyncLog
      }
    )

    return {
      vsMigrationSyncLog,
      tabLockedMessage
    }
  }

  function makeTransactionLogForm() {
    if (vsMigrationSyncLogId === '') {
      return (
        <VsMigrationSyncLogAddForm
          history={history}
          showNotification={showNotification}
          onPostSubmitSuccess={(datum) => {
            setVsMigrationSyncLogId(datum.id)
            setLockedOnFirstTab(false)
          }}
        />
      )
    } else {
      return (
        <VsMigrationSyncLogEditForm
          showNotification={showNotification}
          id={vsMigrationSyncLogId}
        />
      )
    }
  }

  return (
    <Grid container spacing={3}>
      {/* <Grid item xs={12}>
        <Paper>
          <Container maxWidth='xl'>
            <VsMigrationSyncLogViewForm
              showNotification={showNotification}
              id={vsMigrationSyncLogId}
            />
          </Container>
        </Paper>
      </Grid> */}
      <Grid item xs={12}>
        <CngTabs
          headerColor='primary'
          tabs={[
            {
              tabName: translatedTextsObject.transactionLog,
              tabContent: makeTransactionLogForm()
            },
          ]}
          lockedOnFirstTab={lockedOnFirstTab}
          tabLockedMessage={translatedTextsObject.tabLockedMessage}
        />
      </Grid>
    </Grid>
  )
}

export default AddPage